import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import { fetchSellerProfile } from '@/shared/persistence/user';

export const sellerProfileQueryParams = {
  queryKey: ['sellerProfile'],
  queryFn: fetchSellerProfile,
};
export const useSellerProfile = () => {
  const result = useQuery({
    ...sellerProfileQueryParams,
    select: (data) => data.profile,
    staleTime: minutesToMilliseconds(5),
  });

  return { user: result.data };
};
